// extracted by mini-css-extract-plugin
export default {"container":"SmallBox_container__ZF-jJ","number":"SmallBox_number__qY76x","shimmer":"SmallBox_shimmer__zeXbL","text":"SmallBox_text__z7RxN"};